export enum TariffOptions {
  ManageTariffs = 'tariffs',
  TariffSetup = 'tariff-setup',
}
